import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import './Navbar.css'

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const [hoveredItem, setHoveredItem] = useState(null)
  const location = useLocation()
  const [currentPage, setCurrentPage] = useState('home')

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  useEffect(() => {
    // Detect current page from URL pathname
    const path = location.pathname
    if (path === '/games') setCurrentPage('games')
    else if (path === '/support') setCurrentPage('support')
    else if (path === '/career') setCurrentPage('career')
    else setCurrentPage('home')
  }, [location])

  const isLogoHighlighted = hoveredItem === 'home' || currentPage === 'home'

  return (
    <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <Link 
            to="/" 
            className={`logo ${isLogoHighlighted ? 'active' : ''}`}
            onMouseEnter={() => setHoveredItem('home')}
            onMouseLeave={() => setHoveredItem(null)}
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <img src="/assets/images/logo-white.png" alt="Logo" className="logo-white" />
            <img src="/assets/images/logo-blue.png" alt="Logo" className="logo-blue" />
          </Link>

          <ul className={`nav-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <li className="nav-item">
              <Link 
                to="/games" 
                className={`nav-link ${currentPage === 'games' ? 'active' : ''}`}
                onMouseEnter={() => setHoveredItem('games')}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Games
              </Link>
            </li>
            <li className="nav-item">
              <Link 
                to="/support" 
                className={`nav-link ${currentPage === 'support' ? 'active' : ''}`}
                onMouseEnter={() => setHoveredItem('support')}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Support
              </Link>
            </li>
            <li className="nav-item">
              <a 
                href="https://emploi.afjv.com/annonces-societes/2024" 
                target='_blank'
                className={`nav-link ${currentPage === 'career' ? 'active' : ''}`}
                onMouseEnter={() => setHoveredItem('career')}
                onMouseLeave={() => setHoveredItem(null)}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Career
              </a>
            </li>
          </ul>

          <button 
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  )
}

export default Navbar
